import { h, Component } from "preact";

import style from './style';

class UpAnchor extends Component {
  goUp() {
    // This wont work in a pure functional component where window is not available
    window.scrollTo(0,0);
  }

  render() {
    return (
      <div class={style['up-anchor']} onClick={this.goUp}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </div>
    );
  }
};

export default UpAnchor;
